exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.tabs-button {\n    /* flex-grow: 0; */\n    padding: 8px;\n    border: 2px solid white;\n    border-bottom: none;\n    background: transparent;\n    color: white;\n    cursor: pointer;\n}\n\n.tabs-button.active {\n    background: white;\n    color: black;\n}\n\n.tabs-button + .tabs-button {\n    border-left: none;\n}\n\n.tabs-content {\n    flex-grow:1;\n    display: flex;\n    flex-direction: column;\n    background: white;\n}", ""]);

// exports
